module.exports = __webpack_public_path__ + "static/img/logo_am.7aa8b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_am.png
// module id = +/WI
// module chunks = 1